export const AUDIT_PERSON_CREATE_PAGE_PATH = '/audit/person/create'

export const AUDIT_PERSON_EDIT_PAGE_PATH = '/audit/person/edit'

export const AUDIT_PERSON_DETAIL_PAGE_PATH = '/audit/person/detail'

export const AUDIT_PERSON_RESULT_PAGE_PATH = '/audit/person/result'
